import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import BlockForm from '../../Admin/Pages/Blocks/BlockForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCog } from '@fortawesome/pro-duotone-svg-icons/faCog'

export default class BlockEditButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: false,
        }
    }

    render() {
        const kedo = this.props.kedo

        return (
            <>
                {this.state.edit ? (
                    <BlockForm
                        variant={'edit'}
                        item={this.props.item}
                        kedo={kedo}
                        handleClose={this.props.handleClose}
                        onClose={() => this.setState({ edit: false })}
                        onSuccess={() => {
                            this.setState({ edit: false })
                            this.props.onSuccess()
                        }}
                    />
                ) : null}
                <Tooltip title={kedo.t('Settings')}>
                    <IconButton
                        size="small"
                        onClick={() => this.setState({ edit: true })}
                    >
                        <FontAwesomeIcon icon={faCog} />
                    </IconButton>
                </Tooltip>
            </>
        )
    }
}
